import { NgModule } from '@angular/core';
import { MatSnackBarModule } from '@angular/material/snack-bar';

import { ThemeConfigModule } from '../core/config/theme/theme.config.module';

import { EmptyLayoutComponent } from './components/empty/empty.component';
import { UltramarineLayout } from './components/ultramarine-layout/ultramarine-layout.component';
import { LayoutComponent } from './layout.component';

@NgModule({
	imports: [
		MatSnackBarModule,
		ThemeConfigModule,
		EmptyLayoutComponent,
		UltramarineLayout,
		LayoutComponent,
	],
	exports: [LayoutComponent, EmptyLayoutComponent, UltramarineLayout],
})
export class LayoutModule {}
